// @ts-nocheck
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Store Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackPowerBiEventsParameters extends TrackEventBaseParameters {
    event_type?: "page_changed" | "saved" | "data_selected" | "button_clicked";
}

const trackPowerBi = (parameters: TrackPowerBiEventsParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "powerbi_event", ...parameters }, options);
};

export default trackPowerBi;
